//可以生成明细列表（名称，单价，数量，总价），计算就依据这个。全列出来，也可以过滤有效的计算总价？
//        有效记录加标记？
//还要记录分项的总价（票价，优惠，可选项，...），保存每 个分项在列表中的索引起止？

//可获取有效票价类型，和名称
//每种票价对应的价格名称？
//当前使用了什么优惠，类型和层级!!!!!
//
//只用于输入数据和产生金额，不负责显示数据更新
//
//
//参数：
//1.是否启用优惠计算
//2.销售类型sellMode（暂不需要）
//3.计划信息
//4.可选项信息
//
//成员变量：
//1. 明细列表：[{}]（类型{票价、优惠1、优惠2、可选项}，code/id, 名称，单价，数量，总价，有效项目{还是直接判断数量？}）
//        通过计划信息、可选项信息、有效票价类型产生。票价类型只存有用记录
//        如果不启用优惠，则优惠存列表
//2. 类型的索引和总计金额:{ticket:{start:0, end:2, total: 100.00}, addi: {...}}
//3. 是否启用优惠计算
//4. 优惠配置：{ 人数：{}， 提前：{}}
//        人数：[人数1，人数2，人数3]  明细中的索引计算出来？
//        提前：[时间1，时间2]
//
//注：签证没有提前优惠，还未测试
var numeral = require('numeral')

class OrderAmount {
  priceTypes = ['a', 'b', 'c', 'd']

  items = []

  labelTempleteCfg = {}

  category = {} //{ start, end, total, labelTemplete}

  favorableCfg = {} //记录对应优惠，每个级别的参数（人数、时间）;判断是否达到标准的方法

  favorableActive = { type: null, level: -1 }

  nums = [0, 0, 0, 0]

  totalNum = 0

  totalAmount = 0.0

  favorableAmount = 0.0 //订单优惠总金额

  constructor(
    plan,
    additionals,
    effectPriceTypes,
    favorableRank,
    enableFavorable = true,
    labelTempleteCfg
  ) {
    this.effectPriceTypes = effectPriceTypes

    this.enableFavorable = enableFavorable

    this._initLabelTempleteCfg(labelTempleteCfg)

    this._initFavorableCfg(plan, favorableRank) //favorableRank定义优惠中哪些级别的数据可用。如:{ favorable_advance: 1 favorable_num: 2}表示提前优惠未定义；人数优惠有1级定义

    this._parseTicketInfo(plan)

    for (let fType in this.favorableCfg) {
      this._parseFavorable(plan, fType)
    }

    if (additionals && additionals.length > 0) {
      this._pareseAdditional(additionals)
    }

    this.departTime = plan.depart_time

    // console.log(this.favorableCfg);
    // console.log(this.items);
    // console.log(this.category);
    //       console.log(this.effectPriceTypes[0]);
    //       console.log(this.enableFavorable);
  }

  //获取价格明细
  itemList(active = true) {
    if (active) {
      let list = []
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].num > 0) {
          list.push(this.items[i])
        }
      }
      return list
    } else {
      return this.items
    }
  }

  //获取当前生效的优惠类型和级别的明细
  favorableItemList(active = true) {
    let list = []
    this.favorableAmount = 0.0
    if (this.favorableActive.type) {
      let activeCategory = this.category[this.favorableActive.type]
      let range = this._parseRange(
        activeCategory.start,
        this.favorableActive.level
      )
      for (let i = range.start; i < range.end; i++) {
        if (!active || this.items[i].num > 0) {
          list.push(this.items[i])
          this.favorableAmount += this.items[i].price * this.items[i].num
        }
      }
    }
    return list
  }

  //获取订单总金额(应付)
  getTotalAmount() {
    return this.totalAmount
  }

  //获取总票价数量
  getTotalNum() {
    return this.totalNum
  }

  //获取当前生效的优惠类型和级别
  getFavorableActive() {
    return this.favorableActive
  }

  getFavorableActiveType() {
    return this.favorableActive.type
  }

  //设置指定票价类型的数量
  setTicketNum(index, num) {
    if (index < 0 || index > 3) {
      return this.totalAmount
    }
    num = parseInt(num, 10)
    if (this.nums[index] == num || num < 0 || num > 999) {
      return this.totalAmount
    }
    //
    this.nums[index] = num
    //更新新总人数
    this._updateTotalNum()
    //更新票价 -----------------------
    this._updateCategoryOneItem('ticket', index, num)

    //更新优惠 -----------------------
    if (this.enableFavorable) {
      this._updateFavorableCategoryItems()
    }
    //更新总金额
    this._updateTotalAmount()

    return this.totalAmount
  }

  //初始化票价数量
  initTicketNums(nums) {
    if (!Array.isArray(nums) || nums.length !== 4) {
      return this.totalAmount
    }
    for (let i = 0; i < this.nums.length; i++) {
      let n = parseInt(nums[i], 10)
      this.nums[i] = n < 0 || n > 999 ? 0 : n
    }

    //更新新总人数
    this._updateTotalNum()
    //更新票价 -----------------------
    this._updateTicketCategoryItems()

    //更新优惠 -----------------------
    if (this.enableFavorable) {
      this._updateFavorableCategoryItems()
    }
    //更新总金额
    this._updateTotalAmount()

    return this.totalAmount
  }

  setAdditionalNum(id, num) {
    if (!id) {
      return this.totalAmount
    }
    num = parseInt(num, 10)
    if (num < 0 || num > 999) {
      return this.totalAmount
    }
    this._updateCategoryOneItem('additional', id, num)
    //更新总金额
    this._updateTotalAmount()

    return this.totalAmount
  }

  _initLabelTempleteCfg(cfg) {
    if (cfg) {
      this.labelTempleteCfg = cfg
    } else {
      this.labelTempleteCfg = {
        favorable_num: '$优惠',
        favorable_advance: '$优惠'
      }
    }
  }

  _updateCategoryOneItem(type, code, num) {
    let thisCategory = this.category[type]
    let change = this._updateItem(thisCategory, code, num)
    if (change) {
      thisCategory.total = this._calcItemsTotal(thisCategory)
    }
    return change
  }

  _updateTicketCategoryItems() {
    let ticketCategory = this.category.ticket
    let change = false
    for (let i = 0; i < this.nums.length; i++) {
      if (this._updateItem(ticketCategory, i, this.nums[i])) {
        change = true
      }
    }
    if (change) {
      ticketCategory.total = this._calcItemsTotal(ticketCategory)
    }
    return change
  }

  _updateTotalNum() {
    let newTotalNum = 0
    for (let i = 0; i < this.nums.length; i++) {
      newTotalNum = newTotalNum + this.nums[i]
    }
    this.totalNum = newTotalNum
  }

  _numFavorableMatch(val) {
    // console.log('fn1=' + this.totalNum + ',' + val);
    return val > 0 && this.totalNum >= val
  }

  _advanceFavorableMatch(val) {
    // console.log('fn1=' + this.totalNum + ',' + val);
    return val != this.departTime && new Date().getTime() < val
  }

  _updateFavorableCategoryItems() {
    //先清空原有优惠的
    if (this.favorableActive.type) {
      // let activeCategory = this.category[this.favorableActive.type];
      // this._resetFavorableItems(this._parseRange(activeCategory.start, this.favorableActive.level), this.favorableActive.type);
      this._resetCategoryItems(this.favorableActive.type)
      this._updateFavorableActive()
    }
    //如果总人数小于1，不需要再计算优惠
    if (this.totalNum < 1) {
      return this.totalAmount
    }

    //计算优惠。2个都计算，再重置清掉优惠少的
    let rs = {} //类型 -> 金额
    for (let fType in this.favorableCfg) {
      rs[fType] = this._updateFavorableTypeItems(fType)
    }
    //比较最优惠的类型
    let min = 0
    let minFType = null
    for (let fType in rs) {
      if (rs[fType] >= 0 && this.category[fType].total < min) {
        //先重置上一个最优惠
        if (minFType) {
          this._resetCategoryItems(minFType)
        }
        //标记当前最优惠
        min = this.category[fType].total
        minFType = fType
      }
    }
    //记录当前使用优惠
    if (minFType) {
      this._updateFavorableActive(minFType, rs[minFType])
    }
  }

  _updateFavorableActive(type = null, level = -1) {
    this.favorableActive.type = type
    this.favorableActive.level = level
  }

  _updateFavorableTypeItems(fType) {
    let list = this.favorableCfg[fType].rank
    let thisCategory = this.category[fType]
    let level = -1
    if (list) {
      for (let i = list.length - 1; i >= 0; i--) {
        let boundVal = list[i]
        // console.log(this.favorableCfg[fType].fn);
        if (this.favorableCfg[fType].fn.call(this, boundVal)) {
          // if(boundNum > 0 && this.totalNum >= boundNum) {
          let fRange = this._parseRange(thisCategory.start, i)

          if (this._updateTicketItems(fRange)) {
            level = i
            thisCategory.total = this._calcItemsTotal(fRange)
          }
          break
        }
      }
    }
    return level
  }

  //解析优惠处理范围
  _parseRange(start, level) {
    let effectSize = this.effectPriceTypes.length
    let offset = effectSize * level //有效票价类型 * 第几层级的优惠
    let s = start + offset
    let e = s + effectSize
    return { start: s, end: e }
  }

  _updateTotalAmount() {
    let t = numeral(0.0)
    for (let c in this.category) {
      t = t.add(this.category[c].total)
    }
    this.totalAmount = t.value()
  }

  _calcItemsTotal(range) {
    let newTotal = numeral(0.0)
    for (let i = range.start; i < range.end; i++) {
      newTotal.add(this.items[i].total)
    }
    return newTotal.value()
  }

  _updateItem(range, code, num) {
    for (let i = range.start; i < range.end; i++) {
      let item = this.items[i]
      if (item.code == code) {
        item.num = num
        item.total = numeral(item.price)
          .multiply(num)
          .value() //单价 * 数量
        return true //找到匹配项目并更新
      }
    }
    return false //未找到匹配项目
  }

  _updateTicketItems(range) {
    //方法名不对！！！！！！！！！！！！！！！！
    let change = false
    for (let n = 0; n < this.nums.length; n++) {
      if (this.nums[n] <= 0) {
        continue
      }

      let c = this._updateItem(range, n, this.nums[n])
      if (c && change === false) {
        change = true
      }
    }
    return change
  }

  _resetCategoryItems(type) {
    let thisCategory = this.category[type]
    for (let i = thisCategory.start; i < thisCategory.end; i++) {
      this.items[i].total = 0.0
      this.items[i].num = 0
    }
    thisCategory.total = 0.0
  }

  _initFavorableCfg(plan, favorableRank) {
    this._initFavorableCfgItem(
      plan,
      favorableRank,
      'favorable_num',
      'favorable$_num_a'
    )
    this._initFavorableCfgItem(
      plan,
      favorableRank,
      'favorable_advance',
      'advance_time$'
    )
  }

  _initFavorableCfgItem(plan, favorableRank, type, key) {
    if (favorableRank[type] && favorableRank[type] > 1) {
      //有设置优惠
      let cfg = { rank: [] }
      for (let i = 1; i < favorableRank[type]; i++) {
        let realKey = key.replace(/\$/, i)
        cfg.rank.push(this._parsePlanInfo(plan, realKey))
      }

      //
      if (type === 'favorable_num') {
        cfg.fn = this._numFavorableMatch
        cfg.minus_prefix = 'favorable'
      } else if (type === 'favorable_advance') {
        cfg.fn = this._advanceFavorableMatch
        cfg.minus_prefix = 'advance'
      }
      this.favorableCfg[type] = cfg
    }
  }

  _addCategory(category, size) {
    this.category[category] = {
      start: this.items.length,
      end: this.items.length + size,
      total: 0.0
    }
  }

  _addItem(category, code, code2, name, price) {
    let templete = this.labelTempleteCfg[category]
    let label = templete ? templete.replace(/\$/, name) : name
    this.items.push({
      category: category,
      code: code,
      name: name,
      label: label,
      price: price,
      num: 0,
      total: 0.0
    })
  }

  _parseTicketInfo(plan) {
    this._addCategory('ticket', this.effectPriceTypes.length)

    for (let i = 0; i < this.effectPriceTypes.length; i++) {
      let type = this._paresePriceType(plan, i)
      this._addItem(
        'ticket',
        this.effectPriceTypes[i],
        type,
        this._parsePriceName(plan, type),
        this._parsePlanInfo(plan, 'price_', type)
      ) //+ '票价'
    }

    // this._updateCategoryEnd('ticket');
  }

  _parseFavorable(plan, fType) {
    let range =
      this.favorableCfg[fType].rank.length * this.effectPriceTypes.length
    this._addCategory(fType, range)
    for (let n = 0; n < range; n++) {
      for (let i = 0; i < this.effectPriceTypes.length; i++) {
        let type = this._paresePriceType(plan, i)
        let key = this.favorableCfg[fType].minus_prefix + (n + 1) + '_minus_'
        this._addItem(
          fType,
          this.effectPriceTypes[i],
          n,
          this._parsePriceName(plan, type),
          -this._parsePlanInfo(plan, key, type)
        ) //+ '人数优惠'或'优惠'， 可以另设置？
      }
    }
  }

  _pareseAdditional(additionals) {
    this._addCategory('additional', additionals.length)

    for (let i = 0; i < additionals.length; i++) {
      let info = additionals[i]
      this._addItem(
        'additional',
        info.additional_cost_id,
        '',
        info.additional_cost_name,
        info.price
      )
    }
  }

  _paresePriceType(plan, effectIndex) {
    return this.priceTypes[this.effectPriceTypes[effectIndex]]
  }

  _parsePriceName(plan, priceType) {
    return this._parsePlanInfo(plan, 'price_name_', priceType)
  }

  _parsePlanInfo(plan, prefix, priceType) {
    priceType = priceType || ''
    return plan[prefix + priceType]
  }
}
export { OrderAmount }



// WEBPACK FOOTER //
// ./src/api/order/orderAmount.js